import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Moment from 'moment';
import ShowHistoryComponent from './../Components/ShowHistoryComponent.jsx';
import {
  getScenariosByNameOrderByDate,
  prodBuildsVersion,
  topicBuildsVersion,
  cachedDispatchersByType,
  paramsByJobIds,
  getDispatcherType,
  getModalVisibility,
  getModalInfoByOwner
} from './../reducers';
import {
  modal as modalActions,
  fetchScenariosByDispatcherIds,
  params as paramActions
} from './../actions';
import { owners } from './../helpers/modals';
import { params as paramsConstant } from './../helpers';


export class ShowHistoryContainer extends Component {
  static propTypes = {
    visible: PropTypes.bool,
    hide: PropTypes.func,
    scenarioName: PropTypes.string,
    startDate: PropTypes.object,
    submit: PropTypes.func,
    toggleDetails:PropTypes.func,
    runsToShow: PropTypes.number,
    paramsByJobIds: PropTypes.object,
    scenariosToShow: PropTypes.array,
    details: PropTypes.bool,
    dispatcherIds: PropTypes.array,
    fetchScenariosByDispatcherIds: PropTypes.func.isRequired,
    nonEmptyRunnerScenarios: PropTypes.array,
    fetchParamsByJobIds: PropTypes.func.isRequired
  };

  componentDidUpdate() {
    if (this.props.dispatcherIds.length > 0) {
      this.props.fetchScenariosByDispatcherIds(this.props.dispatcherIds);
    }

    if (this.props.nonEmptyRunnerScenarios === undefined ||
      this.props.nonEmptyRunnerScenarios.length === 0) {
      return;
    }
    this.props.fetchParamsByJobIds(
      this.props.nonEmptyRunnerScenarios.map(s => s.runner).filter(x => x));

  }

  render () {
    return (
      <ShowHistoryComponent
        {...this.props}
      />
    );
  }

}
export const mapStateToProps = (state) => {
  const modalInfo = getModalInfoByOwner(state, owners.scenarioHistory);
  const paramsByIds = paramsByJobIds(state);
  const visible = getModalVisibility(state, owners.scenarioHistory);
  const scenarioName = modalInfo.scenarioName;
  const scenarios = getScenariosByNameOrderByDate(state, scenarioName);
  const startDate = modalInfo.startDate;
  const runsToShow = parseInt(modalInfo.runsToShow) || 0;
  const details = modalInfo.details;
  const prodVersions = prodBuildsVersion(state);
  const buildType = modalInfo.buildType;
  const topicVersions = topicBuildsVersion(state);
  const dispatcherType = getDispatcherType(state);
  const dispatcherIds = cachedDispatchersByType(state, dispatcherType).map(d => d.id);
  const nonEmptyRunnerScenarios = scenarios ? scenarios.filter(s => s.runner) : [];

  const scenariosSinceStartDate = scenarios ? scenarios.filter(
    scenario => Moment(startDate).startOf('day').unix() <
    Moment(scenario.created_at).startOf('day').unix()
  ) : [];

  let scenariosToShow = [];
  if (buildType === 'Production' && prodVersions) {
    scenariosToShow = scenariosSinceStartDate.filter(
      s => paramsByIds[s.runner] &&
        prodVersions.indexOf(paramsByIds[s.runner][paramsConstant.JENKINS_IEF_VER]) !== -1
    );
  } else if (topicVersions) {
    scenariosToShow = scenariosSinceStartDate.filter(
      s => paramsByIds[s.runner] &&
      topicVersions.indexOf(paramsByIds[s.runner][paramsConstant.JENKINS_IEF_VER]) !== -1
    );
  }

  return {
    visible,
    scenariosToShow,
    startDate,
    runsToShow,
    scenarioName,
    details,
    dispatcherIds: dispatcherIds ? dispatcherIds.slice(
      dispatcherIds.length - 50, dispatcherIds.length) : [],
    paramsByJobIds: paramsByIds,
    nonEmptyRunnerScenarios
  };
};

export default connect(
  mapStateToProps,
  {
    fetchScenariosByDispatcherIds,
    fetchParamsByJobIds: paramActions.fetchParamsByJobIds,
    submit: (historyInfo) =>
      modalActions.setHistoryInfo(
        historyInfo.startDate, historyInfo.scenarioName, historyInfo.runsToShow,
        historyInfo.buildType),
    toggleDetails: () => modalActions.toggleHistoryDetails(),
    hide: () => modalActions.showHistory(false, '')
  }
)(ShowHistoryContainer);


// WEBPACK FOOTER //
// src/Containers/ShowHistoryContainer.jsx